
<button
  class="sdv-button sdv-embed-component"
  :class="classes"
  @click="$emit('click')"
>
  <span class="sdv-focus-helper" />
  <span class="sdv-button__content">
    <SdvIcon
      v-if="svg"
      :class="leftIconClasses"
      :svg="svg"
    />
    <slot>
      {{ label }}
    </slot>
  </span>
</button>
